// 客户池
import request from '@/utils/request'
let BASEROOT          = '/visitor/v2'

/**
 *  添加客户池
 *  @param  userId       加入客户池客商ID
 *  @param  source       来源,电话:PHONE,站内添加:INSTATION
 */
export function addCustomerPool(query) {
  return request({
    url: BASEROOT + '/contactPerson/addCustomerPool',
    method: 'post',
    data: query
  })
}

/**
 *  添加客户池
 *  @param  pageNum      页码
 *  @param  pageRows     每页显示数量
 */
export function getRecordPage(query) {
  return request({
    url: BASEROOT + '/invitation/getRecordPage',
    method: 'post',
    data: query
  })
}
